module.exports = __webpack_public_path__ + "media/images/country_flags/cz-05ea89d0ce27c09cf79aa7ac72da4b6d.png";